import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const SouthDakota = () => {
  const [showAllCities, setShowAllCities] = useState(false);

  useEffect(() => {
    // Set document title and meta tags
    document.title = 'We Buy Valves South Dakota | Industrial Equipment Buyers South Dakota';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional industrial equipment buyers throughout South Dakota. We buy valves, control systems, and instrumentation from Sioux Falls, Rapid City, and all South Dakota facilities at above scrap rates.');
    }
    
    // Set meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'south dakota valve buyers, we buy valves south dakota, industrial equipment buyers south dakota, surplus valve buyers');
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/south-dakota');
    
    // Set Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'We Buy Valves South Dakota | Industrial Equipment Buyers South Dakota' },
      { property: 'og:description', content: 'Professional industrial equipment buyers throughout South Dakota. We buy valves, control systems, and instrumentation from Sioux Falls, Rapid City, and all South Dakota facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/south-dakota' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    // Set geo location tags
    let geoPosition = document.querySelector('meta[name="geo.position"]');
    if (!geoPosition) {
      geoPosition = document.createElement('meta');
      geoPosition.setAttribute('name', 'geo.position');
      document.head.appendChild(geoPosition);
    }
    geoPosition.setAttribute('content', '43.9695;-99.9018');
    
    let geoRegion = document.querySelector('meta[name="geo.region"]');
    if (!geoRegion) {
      geoRegion = document.createElement('meta');
      geoRegion.setAttribute('name', 'geo.region');
      document.head.appendChild(geoRegion);
    }
    geoRegion.setAttribute('content', 'US-SD');
    
    let geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (!geoPlacename) {
      geoPlacename = document.createElement('meta');
      geoPlacename.setAttribute('name', 'geo.placename');
      document.head.appendChild(geoPlacename);
    }
    geoPlacename.setAttribute('content', 'South Dakota, United States');
    
    // Set last-modified
    let lastModified = document.querySelector('meta[http-equiv="last-modified"]');
    if (!lastModified) {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('http-equiv', 'last-modified');
      document.head.appendChild(lastModified);
    }
    lastModified.setAttribute('content', new Date().toISOString());

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply South Dakota Operations",
          "image": "https://valvesalessupply.com/logo.png",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "SD",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 43.9695,
            "longitude": -99.9018
          },
          "telephone": "+1-214-854-5638",
          "email": "valvesalessupply@gmail.com",
          "url": "https://valvesalessupply.com/south-dakota",
          "priceRange": "$$",
          "serviceArea": {
            "@type": "State",
            "name": "South Dakota",
            "addressRegion": "SD"
          },
          "description": "Professional industrial equipment purchasing services throughout South Dakota, serving manufacturing facilities, grain processing operations, and industrial plants in Sioux Falls, Rapid City, and surrounding areas."
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of valves do you buy in South Dakota?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase all types of industrial valves including control valves, ball valves, gate valves, butterfly valves, check valves, safety relief valves, and specialty valves from South Dakota facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Which South Dakota cities do you serve?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We serve all major South Dakota cities including Sioux Falls, Rapid City, Aberdeen, Brookings, Watertown, Mitchell, Yankton, Pierre, Huron, Vermillion, and all surrounding areas throughout the state."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you respond in South Dakota?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide same-day response for Sioux Falls and Rapid City areas, with 6-10 hour response times throughout South Dakota depending on location."
              }
            }
          ]
        },
        {
          "@type": "ItemList",
          "name": "South Dakota Cities We Serve",
          "numberOfItems": 2,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Place",
                "name": "Sioux Falls",
                "url": "https://valvesalessupply.com/sioux-falls",
                "description": "Major ethanol production, food processing, and manufacturing center serving Eastern South Dakota"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Place",
                "name": "Rapid City",
                "url": "https://valvesalessupply.com/rapid-city",
                "description": "Mining operations, cement production, and industrial facilities in the Black Hills region"
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Service Areas",
              "item": "https://valvesalessupply.com/service-areas"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "South Dakota",
              "item": "https://valvesalessupply.com/south-dakota"
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const southDakotaFacilities = [
    { name: 'Sioux Falls', facilities: 'Processing Plants', response: '6-8 Hours' },
    { name: 'Aberdeen', facilities: 'Industrial Facilities', response: '7-9 Hours' },
    { name: 'Rapid City', facilities: 'Processing Plants', response: '8-10 Hours' }
  ];

  const southDakotaCities = [
    'Aberdeen', 'Belle Fourche', 'Beresford', 'Box Elder', 'Brandon', 'Brookings', 'Canton', 'Chamberlain',
    'Custer', 'Deadwood', 'Dell Rapids', 'Eagle Butte', 'Fort Pierre', 'Freeman', 'Harrisburg', 'Hot Springs',
    'Huron', 'Lead', 'Lennox', 'Madison', 'Martin', 'Milbank', 'Miller', 'Mitchell',
    'Mobridge', 'North Sioux City', 'Parker', 'Pierre', 'Platte', 'Rapid City', 'Redfield', 'Sioux Falls',
    'Sisseton', 'Spearfish', 'Sturgis', 'Tea', 'Vermillion', 'Volga', 'Watertown', 'Webster',
    'Winner', 'Yankton'
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/fa837628e757bf117f83db7881237d71.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              We Buy Valves South Dakota
            </h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Professional surplus equipment buyer serving South Dakota industrial and processing facilities. 
              We purchase valves, control systems, and instrumentation from Sioux Falls, Aberdeen, Rapid City, 
              and throughout South Dakota at above scrap rates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:(214) 854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL (214) 854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET SOUTH DAKOTA QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* South Dakota Market */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">SURPLUS EQUIPMENT BUYER SOUTH DAKOTA</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                South Dakota's industrial facilities require professional <strong className="text-[#1B3A5F]">surplus equipment removal</strong> 
                services during maintenance projects and facility upgrades. We provide reliable equipment purchasing services 
                throughout the state.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                As experienced <strong className="text-[#1B3A5F]">industrial equipment buyers</strong>, we understand the 
                value of quality equipment and pay fair market prices for functional surplus assets from South Dakota facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">5+</div>
                  <div className="text-gray-600">SD Facilities</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">6-10 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">10 Years</div>
                  <div className="text-gray-600">Regional Experience</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">SOUTH DAKOTA SERVICE AREAS</h3>
              <div className="space-y-4">
                {southDakotaFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.facilities}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">Response:</div>
                      <div className="text-gray-600 text-sm">{facility.response}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* South Dakota Cities We Serve */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              South Dakota Cities We Serve
            </h2>
            <p className="text-gray-600 text-xl">
              Comprehensive valve buying services across South Dakota's key industrial markets
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3">
                    <a href="/sioux-falls" className="hover:text-teal-600 transition-colors">
                      Sioux Falls Valve Buyers
                    </a>
                  </h3>
                  <p className="text-gray-600 mb-4">
                    As South Dakota's largest city, Sioux Falls is home to diverse industrial operations including ethanol production, food processing, and manufacturing. We buy surplus valves from facilities throughout the metro area, offering competitive pricing and fast turnaround times for all valve types and sizes.
                  </p>
                  <a href="/sioux-falls" className="text-teal-600 hover:text-teal-700 font-medium inline-flex items-center gap-2">
                    Learn More <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-hammer-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3">
                    <a href="/rapid-city" className="hover:text-teal-600 transition-colors">
                      Rapid City Valve Buyers
                    </a>
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Serving the Black Hills region, Rapid City supports mining operations, cement production, and tourism infrastructure. We purchase surplus valves from industrial facilities, mining operations, and processing plants. Our team provides expert evaluations and immediate payment for quality valve inventory.
                  </p>
                  <a href="/rapid-city" className="text-teal-600 hover:text-teal-700 font-medium inline-flex items-center gap-2">
                    Learn More <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Sell Valves to Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Why Sell Valves to Us in South Dakota
            </h2>
            <p className="text-gray-600 text-xl">
              Professional valve buying services throughout South Dakota
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-money-dollar-circle-line',
                title: 'Above Scrap Pricing',
                description: 'We pay significantly more than scrap rates for functional valves and instrumentation from South Dakota facilities'
              },
              {
                icon: 'ri-time-line',
                title: 'Fast Response',
                description: 'Same-day response in Sioux Falls and Rapid City, 6-10 hour response throughout South Dakota'
              },
              {
                icon: 'ri-truck-line',
                title: 'Professional Removal',
                description: 'Licensed and insured team handles all equipment removal and transportation throughout the state'
              },
              {
                icon: 'ri-file-list-3-line',
                title: 'Complete Documentation',
                description: 'Full documentation and compliance support for all valve purchases and equipment transfers'
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Licensed & Insured',
                description: 'Fully licensed and insured operations providing professional service to South Dakota facilities'
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'Expert Assessment',
                description: 'Professional evaluation of all valve types with fair market pricing based on condition and specifications'
              }
            ].map((benefit, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-3xl p-8 text-center">
                <div className="w-20 h-20 bg-[#1B3A5F] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${benefit.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY INDUSTRIAL EQUIPMENT SOUTH DAKOTA</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from South Dakota industrial facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Equipment Categories</h3>
              <div className="space-y-4">
                {[
                  'Control Valves and Safety Systems',
                  'Processing Equipment and Tanks',
                  'Instrumentation and Controls',
                  'Pumps and Rotating Equipment',
                  'Heat Exchangers and Vessels',
                  'Electrical Control Panels',
                  'Safety and Emergency Systems',
                  'Measurement and Testing Equipment'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">South Dakota Services</h3>
              <div className="space-y-4">
                {[
                  'Professional equipment assessment',
                  'Above scrap rate pricing',
                  'Complete documentation service',
                  'Coordinated removal scheduling',
                  'Emergency equipment removal',
                  'Regulatory compliance support',
                  'Licensed and insured operations',
                  'Statewide service coverage'
                ].map((service, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{service}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">SELL SURPLUS EQUIPMENT SOUTH DAKOTA</h2>
            <p className="text-gray-200 text-xl">Professional equipment buyer serving South Dakota industrial facilities</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">SOUTH DAKOTA CONTACT</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">(214) 854-5638</div>
                    <div className="text-gray-600">South Dakota Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">valvesalessupply@gmail.com</div>
                    <div className="text-gray-600">Equipment Assessments</div>
                  </div>
                </div>
              </div>
              
              <Link
                to="/contact"
                className="w-full bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET SOUTH DAKOTA QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">SOUTH DAKOTA ADVANTAGES</h3>
              <div className="space-y-4">
                {[
                  'Professional surplus equipment removal',
                  'Above scrap pricing for quality equipment',
                  'Reliable service across South Dakota',
                  'Complete documentation and compliance',
                  'Emergency response capabilities',
                  '10+ years regional experience'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* South Dakota Cities Dropdown - Above FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES IN ALL SOUTH DAKOTA CITIES</h2>
            <p className="text-gray-600 text-xl mb-8">Professional valve buying services across South Dakota - Click to view all cities</p>
          </div>

          <div className="bg-[#F5F7FA] rounded-3xl p-8 mb-8">
            <div className="grid md:grid-cols-3 gap-6 mb-6">
              <div className="text-center">
                <div className="text-[#1B3A5F] text-3xl font-bold mb-2">40+</div>
                <div className="text-gray-600">South Dakota Cities Served</div>
              </div>
              <div className="text-center">
                <div className="text-[#1B3A5F] text-3xl font-bold mb-2">6-10 Hours</div>
                <div className="text-gray-600">Average Response Time</div>
              </div>
              <div className="text-center">
                <div className="text-[#1B3A5F] text-3xl font-bold mb-2">Same Day</div>
                <div className="text-gray-600">Equipment Removal Available</div>
              </div>
            </div>
          </div>

          <button
            onClick={() => setShowAllCities(!showAllCities)}
            className="w-full bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap mb-8"
          >
            {showAllCities ? 'HIDE SOUTH DAKOTA CITIES' : 'VIEW ALL SOUTH DAKOTA CITIES'}
            <i className={`${showAllCities ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} ml-2 text-2xl`}></i>
          </button>

          {showAllCities && (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 animate-fadeIn">
              {southDakotaCities.map((city, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-4 border-2 border-[#F5F7FA] hover:border-[#1B3A5F] hover:shadow-lg transition-all duration-300 cursor-pointer"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-[#1B3A5F] font-bold text-lg mb-1">{city}</h3>
                      <p className="text-gray-600 text-sm">We Buy Valves {city} SD</p>
                    </div>
                    <i className="ri-map-pin-line text-[#1B3A5F] text-xl"></i>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "LocalBusiness",
                "@id": "https://valvebuyers.com/sioux-falls",
                "name": "Valve Buyers - Sioux Falls",
                "url": "https://valvebuyers.com/sioux-falls"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "LocalBusiness",
                "@id": "https://valvebuyers.com/rapid-city",
                "name": "Valve Buyers - Rapid City",
                "url": "https://valvebuyers.com/rapid-city"
              }
            }
          ]
        })}
      </script>

      <Footer />
    </div>
  );
};

export default SouthDakota;
